import { useSelector } from 'react-redux'
import { IReducer } from 'src/interface'

export default function useIntlRoute() {
  const { lang } = useSelector((state: IReducer) => state.changeLanguage)
  return (route: string) => {
    const isEnglishLang = lang === 'en'
    const langRoute = isEnglishLang ? '' : `/${lang}`
    return `${langRoute}${route === '/' ? '' : route}`
  }
}
